import axios from 'axios'
import * as CryptoJS from 'crypto-js'
import { STAKE_BACKEND_URL, SERVICE_URL } from '.'
import { useToast } from '../hook/usetoast'

const environment = {
	dbvSTQDV6gwJkEv5IIBQA: SERVICE_URL,
	apiUrl: STAKE_BACKEND_URL
}

const StakeService = () => {
	const REST_API_SERVER = environment.apiUrl
	const toast = useToast()
	const getGen = (url, getTime) => {
		url = `${url}`
		const date = getTime
		const ex_date = Math.round(date / 1000) + 5
		const payload = {
			exp: ex_date,
			isHuman: true
		}

		const token = signToken(payload, url)
		const encrtpted_token = CryptoJS.AES.encrypt(
			token,
			environment.dbvSTQDV6gwJkEv5IIBQA
		).toString()

		return { token: encrtpted_token }
	}


	const base64url = source => {
		let encodedSource = CryptoJS.enc.Base64.stringify(source);
		if (encodedSource.endsWith('=')) {
			let paddingIndex = encodedSource.length;
			while (paddingIndex > 0 && encodedSource[paddingIndex - 1] === '=') {
				paddingIndex--;
			}
			encodedSource = encodedSource.slice(0, paddingIndex);
		}
		encodedSource = encodedSource.replace(/\+/g, '-')
			.replace(/\//g, '_');
		return encodedSource;
	}

	const signToken = (payload, key) => {
		const secret = key
		const token = encodeToken(payload)
		let signature = CryptoJS.HmacSHA256(token, secret)
		signature = base64url(signature)
		const signedToken = `${token}.${signature}`
		return signedToken
	}

	const encodeToken = payload => {
		const header = {
			alg: 'HS256',
			typ: 'JWT'
		}
		const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header))
		const encodedHeader = base64url(stringifiedHeader)
		const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload))
		const encodedData = base64url(stringifiedData)
		const token = `${encodedHeader}.${encodedData}`
		return token
	}

	const handleError = error => {
		let errorMessage
		if (error.response) {
			errorMessage = `Error Code: ${error.response.status}\nMessage: ${error.response.data}`
		} else if (error.request) {
			errorMessage = 'No response received from server.'
		} else {
			errorMessage = `Error: ${error.message}`
		}
		return Promise.reject(errorMessage)
	}

	const doAnotherthing = async () => {
		const datetime = await axios.get(`${REST_API_SERVER}current-time`)
		return datetime.data
	}

	const getStakeRequest = async url => {
		const token = sessionStorage.getItem('user_JWT')
		try {
			const datetime = await doAnotherthing()
			const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
			const headers = {
				'cache-control': 'no-cache',
				'content-type': 'application/json',
				Authorization: token,
				dfhdfjsljds: tokenHandling.token,
			}
			const response = await axios.get(`${REST_API_SERVER}${url}`, { headers })
			
			if (response?.data?.status === 411) {
				toast.error(response?.data?.message)
				sessionStorage.clear()
				localStorage.clear()
				window.location.href = '/'
			} else if (response?.data?.message === "Unauthorized!") {
				toast.error("Session expired!.")
				sessionStorage.clear()
				localStorage.clear()
				window.location.href = '/'
			}else if ( response?.data?.message=== "Your IP is Blocked"){
				toast.error("Your IP is Blocked")
				localStorage.clear()
				sessionStorage.clear()
				window.location.href = '/'
			}
			return response.data
		} catch (error) {
			return handleError(error)
		}
	}

	const postStakeRequest = async (url, requestData) => {
		const token = sessionStorage.getItem('user_JWT')
		try {
			const datetime = await doAnotherthing()
			const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
			const headers = {
				'cache-control': 'no-cache',
				Authorization: token,
				dfhdfjsljds: tokenHandling.token,
			}

			const response = await axios.post(`${REST_API_SERVER}${url}`, requestData, { headers })
			if (response?.data?.status === 411) {
				toast.error(response?.data?.message)
				localStorage.clear()
				sessionStorage.clear()
				window.location.href = '/'
			} else if (response?.data?.message === "Unauthorized!") {
				toast.error("Session expired!.")
				localStorage.clear()
				sessionStorage.clear()
				window.location.href = '/'
			}
			return response.data
		} catch (error) {
			return handleError(error)
		}
	}


	return {
		getStakeRequest,
		postStakeRequest
	}
}

export default StakeService